import React from "react";
import { 
    AlertCircle,
    CircleCheck,
    Clock,
    Laptop,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import NewItemButton from "components/button/NewItemButton";
import SupportTicket from "./components/SupportTicket";
import SupportTabs from "./components/SupportTabs";

const ITSupport = () => {
    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"IT Support"}
                    icon={Laptop}
                    description={"Technical assistance and troubleshooting"}
                    color={"teal"}
                    rightNav={
                        <NewItemButton>
                            <SupportTicket />
                        </NewItemButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Open Tickets"
                            icon={<AlertCircle />}
                            display="2"
                        />
                        <SummaryItem
                            title="In Progress"
                            icon={<Clock />}
                            display="2" 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display="65%" 
                        />
                   </div>
                </SummaryHeader>
                <SupportTabs />
            </div>
        </div>
    )
};
export default ITSupport;